import { BorLetterResponse } from "../../../client";
import { borSideForReport } from "./data";
import styles from "./BorBadge.module.css";

type BorBadgeProps = {
  bor: BorLetterResponse;
  reportId: string;
  onClick?: () => void;
};

/**
 * Small pill badge shown on the dashboard table row and report header
 * when a BOR is in progress (or recently resolved) for a report.
 * Clickable when onClick is provided — opens the BOR modal.
 */
export const BorBadge: React.FC<BorBadgeProps> = ({
  bor,
  reportId,
  onClick,
}) => {
  const side = borSideForReport(bor, reportId);
  const sideLabel = side === "cleared" ? "Current" : "Blocked";

  return (
    <span
      className={`${styles.badge} ${bor.is_resolved ? styles.resolved : styles.active} ${onClick ? styles.clickable : ""}`}
      title={
        bor.is_resolved
          ? `BOR ${bor.rescind_letter_received_at ? "rescinded" : "finalized"} — resolution notifications pending`
          : `BOR in process — ${sideLabel} broker`
      }
      onClick={(e) => {
        if (onClick) {
          e.stopPropagation();
          onClick();
        }
      }}
    >
      <i className="pi pi-arrows-h" style={{ fontSize: "10px" }} />
      BOR
      <span className={styles.side}>({sideLabel})</span>
    </span>
  );
};
